<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div v-if="dialogAction !== 'copy'">Edit Exclusive</div>
            <div v-else>New Exclusive</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">
                What's the content of the Exclusive?
              </div>
              <v-text-field
                v-model="data.content"
                hide-details
                dense
                outlined
                placeholder="Exclusive Content"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Schedule At</div>
              <v-text-field
                readonly
                v-model="scheduledAtDateString"
                hide-details
                dense
                outlined
                placeholder="Scheduled Date"
                @click="openScheduleDateDialog"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Expires At</div>
              <v-text-field
                v-model="expiresAtDateString"
                readonly
                hide-details
                dense
                outlined
                placeholder="Expire Date"
                @click="openExpiryDateDialog"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Entity</div>
              <v-combobox
                :loading="loading"
                v-model="entity"
                :items="reviewedEntities"
                cache-items
                :search-input.sync="searchTerm"
                hide-details
                return-object
                item-text="title"
                item-value="title"
                placeholder="Select Entity"
                no-data-text="Type a name of an entity to search"
                outlined
                chips
                dense
                @change="entitySelected"
              ></v-combobox>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Region</div>
              <v-select
                outlined
                readonly
                dense
                hide-details
                return-object
                :items="regions"
                v-model="region"
                item-text="name"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Vibez Options</div>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Cost</div>
              <v-text-field
                v-model="data.cost"
                hide-details
                dense
                type="number"
                outlined
                placeholder="Ex: 5"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">How many Redeems?</div>
              <v-text-field
                v-model="data.redeemsLeft"
                hide-details
                dense
                type="number"
                outlined
                placeholder="Ex: 5"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <v-checkbox
                label="Is Unlimited?"
                hide-details
                v-model="data.isUnlimited"
              />
              <v-checkbox
                label="Is GeoFenced?"
                hide-details
                v-model="data.isGeoFenced"
              />
              <v-checkbox
                label="Has daily limit?"
                hide-details
                v-model="data.hasDailyLimit"
              />
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Link Button Options</div>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Name</div>
              <v-text-field
                v-model="data.link.name"
                hide-details
                dense
                outlined
                placeholder="Ex: Name"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Url</div>
              <v-text-field
                v-model="data.link.url"
                hide-details
                dense
                outlined
                placeholder="Ex: Url"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <gallery-image-select-section
            ref="exclusiveImageUploadRef"
            @imageSelected="setExclusiveImage"
          />
          <v-layout
            v-if="data.image.url && !selectedExclusiveFromGallery"
            class="mt-3"
          >
            <v-flex>
              <v-card>
                <v-img
                  aspect-ratio="1"
                  :lazy-src="data.image.url"
                  :src="data.image.url"
                />
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout
            v-if="data.image.url && !selectedExclusiveFromGallery"
            class="mt-3"
          >
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Image URL</div>
              <v-text-field
                v-model="data.image.url"
                hide-details
                dense
                outlined
                readonly
                placeholder="Ex: gift"
              ></v-text-field>
            </v-flex>
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Image Thumbnail</div>
              <v-text-field
                v-model="data.image.thumbnail"
                hide-details
                readonly
                dense
                outlined
                placeholder="Ex: gift"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Next Step Options</div>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Message</div>
              <v-text-field
                v-model="data.subCollections.toInsert.message"
                hide-details
                dense
                outlined
                placeholder="Message"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <gallery-image-select-section
            ref="nextStepImageUploadRef"
            @imageSelected="setNextStepImage"
          />
          <v-layout
            v-if="
              data.subCollections.toInsert.attachment &&
                !selectedNextStepFromGallery
            "
            class="mt-3"
          >
            <v-flex>
              <v-card>
                <v-img
                  aspect-ratio="1"
                  :lazy-src="data.subCollections.toInsert.attachment"
                  :src="data.subCollections.toInsert.attachment"
                />
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3" v-if="data.subCollections.toInsert.attachment">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Attachment</div>
              <v-text-field
                v-model="data.subCollections.toInsert.attachment"
                hide-details
                readonly
                dense
                outlined
                placeholder="Attachment"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <time-and-date-select-dialog
      @onDateSelected="onExpiryDateSelected"
      ref="ExpiryTimeAndDateDialogRef"
    />
    <time-and-date-select-dialog
      @onDateSelected="onScheduleDateSelected"
      ref="ScheduleTimeAndDateDialogRef"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import firebase from 'firebase';
import { auth } from '@/plugins/firebase';
import moment from 'moment';
import TimeAndDateSelectDialog from './TimeAndDateSelectDialog.vue';
import _ from 'lodash';
import GalleryImageSelectSection from '@/modules/Assets/components/GalleryImageSelectSection';

// import ImageUploadSection from './ImageUploadSection';
export default {
  components: {
    TimeAndDateSelectDialog,
    // ImageUploadSection,
    GalleryImageSelectSection,
  },
  props: {
    exclusiveDetails: {
      type: Object,
      default: function() {
        return {};
      },
    },
    selectedRegion: {
      type: Object,
      default: function() {
        return {};
      },
    },
    collection: {
      type: String,
      default: function() {
        return '';
      },
    },
  },
  data() {
    return {
      searchTerm: '',
      loading: false,
      updatedImage: false,
      dialog: false,
      dialogAction: '',
      scheduleDateDialog: false,
      expiryDateDialog: false,
      scheduledAtDateField: null,
      expireAtDateField: null,
      scheduledAt: '',
      id: '',
      state: '',
      region: {},
      entity: {},
      stateItems: ['scheduled', 'active', 'cancelled', 'updated', 'deleted'],
      updatedBy: '',
      data: {
        entityId: '',
        content: '',
        cost: 0,
        image: {
          thumbnail: '',
          url: '',
          firebaseUrl: '',
        },
        link: {
          name: '',
          url: '',
        },
        isUnlimited: false,
        isGeoFenced: false,
        hasDailyLimit: false,
        location: {
          latitude: '',
          longitude: '',
        },
        redeemsLeft: 0,
        expiresAt: '',
        subCollections: {
          image: {
            firebaseUrl: '',
            url: '',
            thumbnail: '',
          },
          collectionName: '',
          toInsert: {
            attachment: '',
            for: 'user',
            message: '',
            state: '',
          },
        },
      },
      exclusiveImage: [],
      nextStepImage: [],
      selectedNextStepFromGallery: false,
      selectedExclusiveFromGallery: false,
    };
  },
  computed: {
    ...mapState('$_home', ['regions']),
    ...mapState('$_content', ['uploadProgress']),
    ...mapState('$_entity', ['reviewedEntities']),
    scheduledAtDateString() {
      if (this.scheduledAtDateField) {
        return this.iMoment(this.scheduledAtDateField);
      } else {
        return this.scheduledAt;
      }
    },
    expiresAtDateString() {
      if (this.expireAtDateField) {
        return this.iMoment(this.expireAtDateField);
      } else {
        return this.data.expiresAt;
      }
    },
    changeFieldsCopy() {
      return {
        scheduledAt: this.scheduledAtDateField
          ? this.iMoment(this.scheduledAtDateField)
          : this.scheduledAt,
        type: 'exclusive',
        region: this.region,
        entity: this.entity,
        state: 'scheduled',

        updatedBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },
        data: {
          entityId: this.data.entityId,
          content: this.data.content,
          cost: this.data.cost,
          image: {
            thumbnail: this.data.image.thumbnail,
            url: this.data.image.url,
            firebaseUrl: this.data.image.firebaseUrl,
          },
          link: {
            name: this.data.link.name,
            url: this.data.link.url,
          },
          isUnlimited: this.data.isUnlimited,
          isGeoFenced: this.data.isGeoFenced,
          hasDailyLimit: this.data.hasDailyLimit,
          location: this.entity.location
            ? new firebase.firestore.GeoPoint(
                parseFloat(this.entity.location.latitude),
                parseFloat(this.entity.location.longitude),
              )
            : new firebase.firestore.GeoPoint(
                parseFloat(this.region.latitude),
                parseFloat(this.region.longitude),
              ),
          redeemsLeft: Number(this.data.redeemsLeft),
          expiresAt: this.expireAtDateField
            ? this.iMoment(this.expireAtDateField)
            : this.data.expiresAt,
          totalRedeemed: Number(0),
          subCollections: {
            image: {
              firebaseUrl: this.data.subCollections.image.firebaseUrl,
              url: this.data.subCollections.image.url,
              thumbnail: this.data.subCollections.image.thumbnail,
            },
            collectionName: this.data.subCollections.collectionName,
            toInsert: {
              attachment: this.data.subCollections.image.url,
              for: 'user',
              message: this.data.subCollections.toInsert.message,
              state: '',
            },
          },
        },
      };
    },

    changeFields() {
      return {
        id: this.id,
        scheduledAt: this.scheduledAtDateField
          ? this.iMoment(this.scheduledAtDateField)
          : this.scheduledAt,
        type: 'exclusive',
        region: this.region,
        entity: this.entity,
        state: this.state,

        updatedBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },
        data: {
          entityId: this.data.entityId,
          content: this.data.content,
          cost: Number(this.data.cost),
          image: {
            thumbnail: this.data.image.thumbnail,
            url: this.data.image.url,
            firebaseUrl: this.data.image.firebaseUrl,
          },
          link: {
            name: this.data.link.name,
            url: this.data.link.url,
          },
          isUnlimited: this.data.isUnlimited,
          isGeoFenced: this.data.isGeoFenced,
          hasDailyLimit: this.data.hasDailyLimit,
          location: this.entity.location
            ? new firebase.firestore.GeoPoint(
                parseFloat(this.entity.location.latitude),
                parseFloat(this.entity.location.longitude),
              )
            : new firebase.firestore.GeoPoint(
                parseFloat(this.region.latitude),
                parseFloat(this.region.longitude),
              ),
          redeemsLeft: Number(this.data.redeemsLeft),
          expiresAt: this.expireAtDateField
            ? this.iMoment(this.expireAtDateField)
            : this.data.expiresAt,
          totalRedeemed: Number(this.data.totalRedeemed),
          subCollections: {
            image: {
              firebaseUrl: this.data.subCollections.image.firebaseUrl,
              url: this.data.subCollections.image.url,
              thumbnail: this.data.subCollections.image.thumbnail,
            },
            collectionName: this.data.subCollections.collectionName,
            toInsert: {
              attachment: this.data.subCollections.image.url,
              for: 'user',
              message: this.data.subCollections.toInsert.message,
              state: '',
            },
          },
        },
      };
    },
  },
  watch: {
    searchTerm: _.debounce(function(e) {
      e && this.searchEntities(e);
    }, 300),
  },
  mounted() {
    this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
  },
  methods: {
    ...mapActions({
      updateExclusive: '$_content/updateContent',
      uploadImage: '$_content/uploadImage',
      createNewExclusive: '$_content/createNewContent',

      getRegions: '$_home/getContent',
      getEntities: '$_entity/getContent',
      getExclusives: '$_content/getContent',
      getExclusivesByRegion: '$_content/getContentByRegion',
      searchEntitiesAction: '$_entity/searchContent',
    }),
    entitySelected(entity) {
      console.log('Selected Entity: ', entity);
      if (entity) {
        this.region = entity.region;
      }
    },
    searchEntities(searchTerm) {
      this.loading = true;
      console.log('searching Tags: ', searchTerm);

      this.searchEntitiesAction({
        collection: 'entities',
        mutation: 'updateReviewedEntities',
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    openExpiryDateDialog() {
      this.$refs.ExpiryTimeAndDateDialogRef.toggleDialog(this.data.expiresAt);
    },
    onExpiryDateSelected(dateTime) {
      // console.log("Expiry Selected Date and Time: ", dateTime);
      this.expireAtDateField = dateTime;
    },
    openScheduleDateDialog() {
      this.$refs.ScheduleTimeAndDateDialogRef.toggleDialog(this.scheduledAt);
    },
    onScheduleDateSelected(dateTime) {
      // console.log("Scheduled Selected Date and Time: ", dateTime);
      this.scheduledAtDateField = dateTime;
    },
    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date).toDate();
      }
      return new Date();
    },
    toggleDialog(exclusiveDetails, action) {
      this.dialog = !this.dialog;

      // console.log("Announcement Details: ", announcementDetails);
      if (this.dialog) {
        this.dialogAction = action;
        this.scheduledAtDateField = exclusiveDetails.scheduledAt
          ? exclusiveDetails.scheduledAt.seconds * 1000
          : '';
        // this.expireAtDateField = exclusiveDetails.data.expiresAt.seconds * 1000;
        this.scheduledAt = this.iMoment(
          exclusiveDetails.scheduledAt.seconds * 1000,
        );
        this.region = exclusiveDetails.region;
        this.entity = exclusiveDetails.entity;
        this.state = exclusiveDetails.state;
        this.data = {
          entityId: exclusiveDetails.data.entityId,
          content: exclusiveDetails.data.content,
          cost: exclusiveDetails.data.cost,
          image: {
            thumbnail: exclusiveDetails.data.image.thumbnail,
            url: exclusiveDetails.data.image.url,
            firebaseUrl: exclusiveDetails.data.image.firebaseUrl
              ? exclusiveDetails.data.image.firebaseUrl
              : '',
          },
          link: {
            name: exclusiveDetails.data.link.name,
            url: exclusiveDetails.data.link.url,
          },
          hasDailyLimit: exclusiveDetails.data.hasDailyLimit || false,
          isUnlimited: exclusiveDetails.data.isUnlimited || false,
          isGeoFenced: exclusiveDetails.data.isGeoFenced || false,
          location: {
            latitude: exclusiveDetails.region.latitude,
            longitude: exclusiveDetails.region.longitude,
          },
          redeemsLeft: exclusiveDetails.data.redeemsLeft,
          expiresAt: this.iMoment(
            exclusiveDetails.data.expiresAt.seconds * 1000,
          ),
          totalRedeemed: exclusiveDetails.data.totalRedeemed,
          subCollections: {
            image: {
              firebaseUrl: exclusiveDetails.data.subCollections
                ? exclusiveDetails.data.subCollections.image.firebaseUrl
                  ? exclusiveDetails.data.subCollections.image.firebaseUrl
                  : ''
                : '',
              url: exclusiveDetails.data.subCollections
                ? exclusiveDetails.data.subCollections.image.url
                : '',
              thumbnail: exclusiveDetails.data.subCollections
                ? exclusiveDetails.data.subCollections.image.thumbnail
                : '',
            },
            collectionName: exclusiveDetails.data.subCollections
              ? exclusiveDetails.data.subCollections.collectionName
              : '',
            toInsert: {
              attachment: exclusiveDetails.data.subCollections
                ? exclusiveDetails.data.subCollections.image.url
                : '',
              for: exclusiveDetails.data.subCollections
                ? exclusiveDetails.data.subCollections.toInsert.for
                : '',
              message: exclusiveDetails.data.subCollections
                ? exclusiveDetails.data.subCollections.toInsert.message
                : '',
              state: exclusiveDetails.data.subCollections
                ? exclusiveDetails.data.subCollections.toInsert.state
                : '',
            },
          },
        };
        this.id = exclusiveDetails.id;
      }
    },
    setExclusiveImage(image) {
      this.selectedExclusiveFromGallery = true;
      this.data.image = image;
      // this.exclusiveImage = image;
    },
    setNextStepImage(image) {
      this.selectedNextStepFromGallery = true;
      this.data.subCollections.image = image;
      // this.nextStepImage = image;
    },
    cancel() {
      this.updatedImage = false;
      this.scheduledAtDateField = '';
      this.expireAtDateField = '';
      this.scheduledAt = '';
      this.state = '';
      this.region = {};
      this.entity = {};
      this.data = {
        entityId: '',
        content: '',
        cost: 0,
        image: {
          thumbnail: '',
          url: '',
          firebaseUrl: '',
        },
        link: {
          name: '',
          url: '',
        },
        isUnlimited: false,
        isGeoFenced: false,
        hasDailyLimit: false,
        location: {
          latitude: '',
          longitude: '',
        },
        redeemsLeft: 0,
        expiresAt: '',
        subCollections: {
          image: {
            firebaseUrl: '',
            url: '',
            thumbnail: '',
          },
          collectionName: '',
          toInsert: {
            attachment: '',
            for: 'user',
            message: '',
            state: '',
          },
        },
      };
      // this.images = [];
      this.exclusiveImage = [];
      this.nextStepImage = [];
      if (this.selectedExclusiveFromGallery == true) {
        this.$refs.exclusiveImageUploadRef.galleryImageDeselect();
      }

      if (this.selectedNextStepFromGallery == true) {
        this.$refs.nextStepImageUploadRef.galleryImageDeselect();
      }

      this.selectedExclusiveFromGallery = false;
      this.selectedNextStepFromGallery = false;
      this.dialog = false;
    },
    save() {
      if (this.dialogAction === 'copy') {
        console.log(this.changeFieldsCopy);
        if (Object.keys(this.changeFieldsCopy.entity).length === 0) {
          return alert('Entity is missing yo... smh...');
        }
        this.createNewExclusive({
          details: this.changeFieldsCopy,
          collection: this.collection,
          type: 'Exclusive',
        }).then(() => {
          this.dialogAction = '';
          this.cancel();
          this.getExclusivesByRegion({
            type: 'exclusive',
            collection: this.collection,
            mutation: 'updateExclusives',
            region: this.selectedRegion,
          });
        });
      } else {
        console.log(this.changeFields);

        if (Object.keys(this.changeFields.entity).length === 0) {
          return alert('Entity is missing yo... smh...');
        }

        this.updateExclusive({
          details: this.changeFields,
          collection: this.collection,
          type: 'Exclusive',
        }).then(() => {
          this.cancel();
          this.getExclusivesByRegion({
            type: 'exclusive',
            collection: this.collection,
            mutation: 'updateExclusives',
            region: this.selectedRegion,
          });
        });
      }
    },
  },
};
</script>

<style></style>
